import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { getProjectIDTree } from '../../../../ressources/functionJS/getProjectIDTree';
import { searchKeyInTree } from '../../../../ressources/functionJS/searchKeyInTree';
import * as privilege from '../../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import { glossaire_type_de_vue } from '../../../../ressources/glossaires/glossaire_type_de_vue';
import ofF from '../../../../ressources/Logo/off-f.png';
import oN from '../../../../ressources/Logo/on-f.png';
import * as actions from '../../../../services/actions';
import Bouton from '../../../UI/Bouton/Bouton';
import Popup from '../../../UI/PopupVue/Popup';
import Tableau from '../../../UI/tableau/Tableau';
import AffichageVue from '../../../Vue/AffichageVue/AffichageVue';
import PlanningVue from '../../../Vue/PlanningVue/PlanningVueElectrovanne';
import EditTableauxDeBordFavoris from './EditTableauxDeBordFavoris/EditTableauxDeBordFavoris';

// La section défilement des tableaux de bord est commentée car elle n'est pas fonctionelle et utilisable pour le moment

import {
  VscListUnordered,
  VscNewFile,
  VscRefresh,
  VscSearch,
} from 'react-icons/vsc';
import S from './TableauDeBord.module.scss';
import { useParams } from 'react-router-dom';
const TableauxDeBord = ({ creer, siLaListeAUneValeur }) => {
  const dispatch = useDispatch();
  const { project_id } = useParams();
  const favorite_tableaux_de_bord_list = useSelector(
    (state) => state.accueil?.summary?.tableaux_de_bord || []
  );
  const listeVuesStore = useSelector((state) => state.vue.views_list);
  const summaryViews = useSelector(
    (state) => state.accueil?.summary?.views ?? []
  );
  const listeVues = listeVuesStore.length > 0 ? listeVuesStore : summaryViews;
  const projects_list = useSelector((state) => state.authentifie.projects_list);
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const favorite_dashboards_list = useSelector(
    (state) => state.accueil?.summary?.favorite_dashboards_list || []
  );
  const arborescence_projets = useSelector(
    (state) => state.interfaceClient.arborescence_projets
  );
  const user_id = useSelector((state) => state.authentifie.user_id);
  const favorite_views_list = useSelector(
    (state) => state.vue.favorite_views_list
  );
  const [typeOfView, setTypeOfView] = useState(0);
  const [tableauDeBord_id, setTableauDeBord_id] = useState(null);
  const [afficherPopupVue, setAfficherPopupVue] = useState(false);

  const ouvrirPopupVue = () => setAfficherPopupVue(true);
  const fermerPopupVue = () => {
    setAfficherPopupVue(false);
    setTableauDeBord_id(null);
  };
  const [projectId, setProjectId] = useState(0);
  const [viewId, setViewId] = useState(0);
  const [afficherPopupPlanning, setAfficherPopupPlanning] = useState(false);
  const ouvrirPopupPlanning = () => {
    setAfficherPopupPlanning(true);
  };
  const fermerPopupPlanning = () => {
    setAfficherPopupPlanning(false);
  };

  const [columns, setColumns] = useState([
    {
      dataField: 'favoris',
      text: [checkMot('favoris')],
      sort: true,
      align: 'center',
      headerAlign: 'center',
      style: {
        width: '150px',
      },
      formatter: (cell, row) => {
        const handleToggle = (e) => {
          e.stopPropagation();
          dispatch(actions.reqToggleFavoriteVueV25(row.view_id, 'dashboard'));
        };
        switch (parseInt(cell)) {
          case 0:
            return (
              <button
                onClick={handleToggle}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                <img alt="off" title="Non favori" src={ofF} />
              </button>
            );
          case 1:
            return (
              <button
                onClick={handleToggle}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                <img alt="on" title="Favori" src={oN} />
              </button>
            );
          default:
            return checkMot(cell);
        }
      },
    },
    {
      dataField: 'view_id',
      text: [
        checkMot('id'),
        <Bouton
          key={'view_id_header_search'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('view_id', checkMot('id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      hidden: true,
      align: 'left',
      headerAlign: 'left',
    },
    {
      dataField: 'project_id',
      text: [
        checkMot('projet'),
        <Bouton
          key={'project_id_header_search'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('projet'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      align: 'left',
      headerAlign: 'left',
      hidden: true,
      formatter: (cell) => {
        for (let i = 0; i < projects_list.length; i++) {
          if (projects_list[i].project_id === cell) {
            return projects_list[i].project_name;
          }
        }
        return cell;
      },
    },
    {
      dataField: 'view_name',
      text: [checkMot('nom') + ' '],
      sort: true,
      align: 'left',
      headerAlign: 'left',
      formatter: (cell, row) => {
        return <span title={row.view_title}>{cell}</span>;
      },
    },
    {
      dataField: 'view_title',
      text: [checkMot('descriptif') + ' '],
      sort: true,
      align: 'left',
      headerAlign: 'left',
      hidden: true,
    },
  ]);
  const [listeDesProjetsId, setListeDesProjetsId] = useState([]);

  useEffect(() => {
    dispatch(actions.reqRecupererFavoriteViewsV25());
  }, [dispatch]);

  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      const newListeDesProjetsId = getProjectIDTree(
        searchKeyInTree(
          { nodes: arborescence_projets },
          parseInt(project_id_url)
        )
      );
      dispatch(actions.reqRecupererListeVues(newListeDesProjetsId));
      setListeDesProjetsId(newListeDesProjetsId);
    }
  }, [project_id_url, arborescence_projets, dispatch]);

  const afficherFiltre = (dataField, placeholder) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => (col.dataField === dataField ? { ...col } : col))
    );
  };

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: (row) => {
      if (
        parseInt(row.view_type) ===
          glossaire_type_de_vue.planning_electrovanne ||
        parseInt(row.view_type) === glossaire_type_de_vue.planning_base_vie
      ) {
        setTypeOfView(row.view_type);
        setProjectId(row.project_id);
        setViewId(row.view_id);
        ouvrirPopupPlanning();
      } else {
        setTableauDeBord_id(row.view_id);
        ouvrirPopupVue();
      }
    },
  };

  const donnees_avec_favoris = project_id
    ? listeVues
        .filter((vue) => {
          const isCorrectType =
            parseInt(vue.view_type) === glossaire_type_de_vue.tableau_de_bord ||
            parseInt(vue.view_type) ===
              glossaire_type_de_vue.planning_electrovanne ||
            parseInt(vue.view_type) === glossaire_type_de_vue.planning_base_vie;
          if (!isCorrectType) return false;
          return listeDesProjetsId.includes(parseInt(vue.project_id));
        })
        .map((vue) => ({
          ...vue,
          favoris: favorite_dashboards_list.includes(parseInt(vue.view_id))
            ? 1
            : 0,
        }))
    : favorite_tableaux_de_bord_list.map((vue) => {
        return {
          ...vue,
          favoris: favorite_dashboards_list?.includes(parseInt(vue.view_id))
            ? 1
            : 0,
        };
      }) || [];

  // -----------------------------------
  if (donnees_avec_favoris.length > 0) {
    siLaListeAUneValeur(true);
  }

  return (
    <>
      <Tableau
        privilegeCreer={privilege.creer_des_vues}
        privilegeSupprimer={privilege.supprimer_des_vues}
        creer={creer}
        iconeCreer={<VscNewFile size={15} />}
        cleLigne={'view_id'}
        donnees={donnees_avec_favoris}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <Popup
          hoverText={checkMot('editer_tableaux_de_bord_favoris')}
          typeBoutonAffichage={type_btn.outil}
          ajoutOverlay={S.Overlay}
          icone={<VscListUnordered size={15} />}
        >
          <EditTableauxDeBordFavoris user_id={user_id} />
        </Popup>
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_vues}
          str={checkMot('maj_vues_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            type={type_btn.outil}
            rond={true}
            cliquer={() => {
              dispatch(actions.reqRecupererListeVues(listeDesProjetsId));
            }}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
      <Popup
        sansBouton={true}
        eventAuClique={ouvrirPopupVue}
        eventALaFermeture={fermerPopupVue}
        showModal={afficherPopupVue}
      >
        {afficherPopupVue && <AffichageVue view_id={tableauDeBord_id} />}
      </Popup>
      <Popup
        sansBouton={true}
        eventAuClique={ouvrirPopupPlanning}
        eventALaFermeture={fermerPopupPlanning}
        showModal={afficherPopupPlanning}
      >
        {(typeOfView === glossaire_type_de_vue.planning_electrovanne ||
          typeOfView === glossaire_type_de_vue.planning_base_vie) && (
          <PlanningVue
            viewId={viewId}
            viewType={typeOfView}
            projectId={projectId}
          />
        )}
      </Popup>
    </>
  );
};

export default TableauxDeBord;
